export default {
  name: 'pagination',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
currentPage: 3
  }
}



// WEBPACK FOOTER //
// ./src/views/components/pagination/pagination.component.js